<template>
  <div id="wrapper" style="padding-top: 0">
    <div id="middle" class="container" style="padding: 0">
      <div id="class-page-index" class="marking">
        <div class="course-info" data-id="73">
          <div class="banner"></div>

          <!--普通优惠-->
          <div class="price">
            <span class="discount-price"><sub>￥</sub>12980</span>
            <span class="origin-price">￥21980</span>
          </div>

          <p class="title">Java架构师</p>
          <p class="detail">
            <span>进阶</span>
            <span>2000小时</span>
            <span>1W+人学习</span>
            <span>10.00分</span>
          </p>
        </div>
        <!-- 
        <ul class="page-header-nav">
          <li class="nav-item active" data-tar="pageTop">详情</li>
          <li class="nav-item" data-tar="plan-type-list">课程</li>
        </ul> -->

        <div class="course-pic-list" style="padding-top: 0">
          <img src="//mashibing.com/mcaImage/1.jpg" alt="" />

          <img src="//mashibing.com/mcaImage/2.jpg" alt="" />

          <!-- <work /> -->

          <img src="//mashibing.com/mcaImage/3.jpg" alt="" />
          <img src="//mashibing.com/mcaImage/4.jpg" alt="" />

          <img src="//mashibing.com/mcaImage/5.jpg" alt="" />

          <img src="//mashibing.com/mcaImage/6.jpg" alt="" />
          <img src="//mashibing.com/mcaImage/7.jpg" alt="" />

          <div style="display: none" class="java-main">
            <div class="java-button java-title">
              多线程和高并发（马士兵老师）
            </div>
            <div class="java-button java-subtitle">
              单机高并发应该掌握的线程基础：线程状态，异常与锁等
            </div>
            <div class="java-button java-subtitle">
              解析自旋锁CAS操作与volatile
            </div>
            <div class="java-button java-subtitle">
              JUC包下AtomicXXX类与新的同步机制：Latch Semaphore等
            </div>
            <div class="java-button java-subtitle">
              LockSupport，高频面试题，AQS源码，以及源码阅读方法论
            </div>

            <div class="java-button java-subtitle">
              强软弱虚四种引用以及ThreadLocal的原理与源码
            </div>

            <div class="java-button java-subtitle">
              线程池可用的各种高并发容器详解：CopyOnWriteList，BlockingQueue等
            </div>

            <div class="java-button java-subtitle">
              详解线程池：自定义线程池，JDK自带线程池，ForkJoin，源码解析等(一）
            </div>

            <div class="java-button java-subtitle">
              详解线程池：自定义线程池，JDK自带线程池，ForkJoin，源码解析等(二）
            </div>
            <div class="java-button java-subtitle">
              单机压测工具JMH，单机最快MQ - Disruptor原理解析
            </div>

            <div class="java-button java-title">JVM（马士兵老师）</div>
            <div class="java-button java-subtitle">JVM入门级class文件格式</div>
            <div class="java-button java-subtitle">详解Class加载过程</div>
            <div class="java-button java-subtitle">Java内存模型</div>
            <div class="java-button java-subtitle">内存屏障与JVM指令</div>
            <div class="java-button java-subtitle">
              Java运行时数据区和常用指令
            </div>
            <div class="java-button java-subtitle">
              JVM调优必备理论知识-GC Collector-三色标记
            </div>
            <div class="java-button java-subtitle">JVM调优实战</div>
            <div class="java-button java-subtitle">JVM实战调优</div>
            <div class="java-button java-subtitle">JVM实战调优</div>
            <div class="java-button java-subtitle">垃圾回收算法串讲</div>
            <div class="java-button java-subtitle">VM常见参数总结</div>
            <div class="java-button java-title">redis（周志垒老师）</div>

            <div class="java-button java-subtitle">redis 介绍及NIO原理介绍</div>
            <div class="java-button java-subtitle">
              redis的string类型&bitmap
            </div>
            <div class="java-button java-subtitle">
              redis的list、set、hash、sorted_set、skiplist
            </div>
            <div class="java-button java-subtitle">
              redis的消息订阅、pipeline、事务、modules、布隆过滤器、缓存LRU
            </div>
            <div class="java-button java-subtitle">
              redis的持久化RDB、fork、copyonwrite、AOF、RDB&AOF混合使用
            </div>
            <div class="java-button java-subtitle">
              redis的集群：主从复制、CAP、PAXOS、cluster分片集群01
            </div>
            <div class="java-button java-subtitle">
              redis的集群：主从复制、CAP、PAXOS、cluster分片集群02
            </div>
            <div class="java-button java-subtitle">
              redis开发：spring.data.redis、连接、序列化、high/low api
            </div>

            <div class="java-button java-title">zookeeper（周志垒老师）</div>

            <div class="java-button java-subtitle">
              zookeeper介绍、安装、shell cli 使用，基本概念验证
            </div>
            <div class="java-button java-subtitle">
              zookeeper原理知识，paxos、zab、角色功能、API开发基础
            </div>
            <div class="java-button java-subtitle">
              zookeeper案例：分布式配置注册发现、分布式锁、ractive模式编程
            </div>

            <div class="java-button java-title">mysql调优</div>

            <div class="java-button java-subtitle">
              mysql调优–使用profiles,performance_schema性能监控
            </div>
            <div class="java-button java-subtitle">
              mysql调优–数据类型和schema优化
            </div>
            <div class="java-button java-subtitle">
              mysql调优–索引基本实现原理及索引优化
            </div>
            <div class="java-button java-subtitle">
              mysql调优–mysql索引优化实现细节
            </div>
            <div class="java-button java-subtitle">
              mysql调优–mysql查询优化分析
            </div>
            <div class="java-button java-subtitle">
              mysql调优–mysql分区设计及分区优化
            </div>
            <div class="java-button java-subtitle">
              mysql调优–mysql分区优化2及参数设计优化
            </div>
            <div class="java-button java-subtitle">
              mysql调优–mysql参数设计优化及总结
            </div>
            <div class="java-button java-title">
              高并发负载均衡（周志垒老师）
            </div>

            <div class="java-button java-subtitle">
              高并发负载均衡：网络协议原理
            </div>
            <div class="java-button java-subtitle">
              高并发负载均衡：LVS的DR,TUN,NAT模型推导
            </div>
            <div class="java-button java-subtitle">
              高并发负载均衡：LVS的DR模型试验搭建
            </div>
            <div class="java-button java-subtitle">
              高并发负载均衡：基于keepalived的LVS高可用搭建
            </div>

            <div class="java-button java-title">
              nginx/tenginx（张一明老师）
            </div>

            <div class="java-button java-subtitle">
              Tengine原理、对比、部署、配置、虚拟主机
            </div>
            <div class="java-button java-subtitle">
              Tengine 反向代理、负载均衡、 session共享 等
            </div>
            <div class="java-button java-subtitle">
              Tengine 动静分离 https SSL 非对称加密
            </div>
            <div class="java-button java-subtitle">
              Nginx OpenSSL 自签名证书 xca FastDFS介绍
            </div>

            <div class="java-button java-title">activeMQ（张一明老师）</div>

            <div class="java-button java-subtitle">
              ActiveMQ 应用场景、helloworld、服务器搭建
            </div>
            <div class="java-button java-subtitle">
              ActiveMQ API 持久化 优先级 事务 持久化方式 ack 安全认证
            </div>
            <div class="java-button java-subtitle">
              ActiveMQ 死信队列，独占消费，分组消费，topic，消息类型
            </div>
            <div class="java-button java-subtitle">
              ActiveMQ
              消息发送原理，持久化机制，同步异步，定时、延迟、重试发送、SpringBoot整合
            </div>
            <div class="java-button java-subtitle">
              ActiveMQ 常见面试题 传输协议
            </div>
            <div class="java-button java-subtitle">
              ActiveMQ
              browser、QueueRequestor、prefetchSize、消费缓冲与消息积压、消息到底是推还是拉、同步与异步发送、同步与异步消费
            </div>
            <div class="java-button java-subtitle">
              ActiveMQ JMSCorrelationID、Topic加强 可追溯消息 调优
            </div>
            <div class="java-button java-subtitle">
              ActiveMQ 集群配置 静态集群 动态集群 主备
            </div>
            <div class="java-button java-title">rocketMQ（张一明老师）</div>
            <div class="java-button java-subtitle">
              RocketMQ 功能 大纲 消息中间件应用场景 linux的部署 角色 对比jms
            </div>
            <div class="java-button java-subtitle">
              RocketMQ 消息消费模式 集群消息 广播消息 同步消息 异步消息 单向消息
              批量消息 TAG SQL表达式过滤
            </div>
            <div class="java-button java-subtitle">
              RocketMQ 分布式事务 事务消息 顺序消费 重试机制
            </div>
            <div class="java-button java-subtitle">
              RocketMQ 源码分析 Consumer启动流程 长轮询 ProcessQueue
            </div>
            <div class="java-button java-subtitle">
              RocketMQ 源码分析 MQClientInstance.start 任务调度
            </div>
            <div class="java-button java-subtitle">
              RocketMQ 刷盘机制源码分析 Broker启动流程 源码分析
            </div>
            <div class="java-button java-subtitle">
              RocketMQ NameServer特点 NameServer启动流程
              消息路由之HeartBeat信息收集 集群模式消息存储架构模型 消息路由发现
            </div>
            <div class="java-button java-subtitle">
              RocketMQ 搭建高可用主从同步双写集群，基于raft 协议的 commitlog
              存储库DLeger
            </div>
            <div class="java-button java-subtitle">
              RocketMQ 常见面试题，Topic分布、负载均衡
            </div>
            <div class="java-button java-subtitle">
              RocketMQ 面试总结 SpringBoot开发
            </div>
            <div class="java-button java-subtitle">
              DevOps Jenkins安装 maven git 整合
            </div>

            <div class="java-button java-title">
              Springboot讲解（连鹏举老师）
            </div>
            <div class="java-button java-subtitle">
              ​ 架构体系讲解及springboot入门
            </div>
            <div class="java-button java-subtitle">​ springboot web开发</div>
            <div class="java-button java-subtitle">
              ​ springboot-thymeleaf及数据源配置
            </div>
            <div class="java-button java-subtitle">
              ​ springboot启动源码解析一
            </div>
            <div class="java-button java-subtitle">
              ​ springboot启动源码解析二
            </div>
            <div class="java-button java-subtitle">
              ​ springboot启动源码解析三
            </div>
            <div class="java-button java-subtitle">
              ​ springboot自动装配源码解析
            </div>
            <div class="java-button java-subtitle">
              ​ springboot与tomcat整合源码解析
            </div>

            <div class="java-button java-title">
              亿级流量多级缓存项目（张一明老师）
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量多级缓存高并发系统架构实战一
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量多级缓存高并发系统架构实战二
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量多级缓存高并发系统架构实战三
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量多级缓存高并发系统架构实战四
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量多级缓存高并发系统架构实战五
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量多级缓存高并发系统架构实战六
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量多级缓存高并发系统架构实战七
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量系统架构之限流
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量系统架构之扩容
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量系统架构之降级
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量系统架构之分布式事务原理
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量系统架构之实战流量分发层
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量系统架构之实战域名与https
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量系统架构之网关kong
            </div>
            <div class="java-button java-subtitle">​ 电商系统详情页PLAN A</div>
            <div class="java-button java-subtitle">​ 静态文件生成-rsync</div>
            <div class="java-button java-subtitle">
              ​ 静态化文件生成业务流程及技术选型解析
            </div>
            <div class="java-button java-subtitle">​ Arica开发实战CRUD</div>
            <div class="java-button java-subtitle">​ 静态文件生成</div>
            <div class="java-button java-subtitle">
              ​ html同步，生成首页，批量生成，健康检查
            </div>
            <div class="java-button java-subtitle">
              ​ 单机事务，并发锁，压力测试
            </div>
            <div class="java-button java-subtitle">
              ​ html架构的应用场景，扩容，静态分页实现
            </div>
            <div class="java-button java-subtitle">
              ​ 分页逻辑2，动态加静态，lua访问mysql
            </div>
            <div class="java-button java-subtitle">
              ​ resty_template,静态文件补偿机制实现
            </div>
            <div class="java-button java-subtitle">
              ​ 亿级流量高并发项目总结
            </div>

            <div class="java-button java-title">
              程序员应该掌握的底层知识（马士兵老师）
            </div>

            <div class="java-button java-subtitle">
              java程序员需要了解的底层知识第一课
            </div>
            <div class="java-button java-subtitle">
              硬件和操作系统的底层知识
            </div>
            <div class="java-button java-subtitle">操作系统之进程管理</div>
            <div class="java-button java-subtitle">Linux系统的内存映射</div>
            <div class="java-button java-subtitle">
              内核同步方法及用汇编启动内核
            </div>

            <div class="java-button java-title">内存与IO（周志垒老师）</div>

            ​
            <div class="java-button java-subtitle">
              虚拟文件系统，文件描述符，IO重定向
            </div>
            <div class="java-button java-subtitle">
              内核中PageCache、mmap作用、java文件系统io、nio、内存中缓冲区作用
            </div>
            <div class="java-button java-subtitle">Socket编程BIO及TCP参数</div>
            <div class="java-button java-subtitle">
              C10K问题及NIO精讲和IO模型性能压测
            </div>
            <div class="java-button java-subtitle">
              网络编程之多路复用器及Epoll精讲
            </div>
            <div class="java-button java-subtitle">
              网络编程java API 实战多路复用器开发
            </div>
            <div class="java-button java-subtitle">
              全手写急速理解Netty模型及IO模型应用实战
            </div>
            <div class="java-button java-subtitle">
              Netty之IO模型开发本质手写部分实现推导篇
            </div>
            <div class="java-button java-subtitle">
              全手写基于Netty的RPC框架自定义协议，连接池
            </div>
            <div class="java-button java-subtitle">网络NIO</div>

            <div class="java-button java-title">NIO与Netty源码（黄俊老师）</div>

            <div class="java-button java-subtitle">Java NIO 一</div>
            <div class="java-button java-subtitle">Java NIO 二</div>
            <div class="java-button java-subtitle">NIO之ByteBuffer</div>
            <div class="java-button java-subtitle">Netty 之NIO selector</div>
            <div class="java-button java-subtitle">Netty之内存管理</div>
            <div class="java-button java-subtitle">Netty之内存管理二</div>
            <div class="java-button java-subtitle">NETTY小结</div>
            <div class="java-button java-subtitle">
              Netty 内存管理 （netty源码）
            </div>
            <div class="java-button java-subtitle">Netty 内存管理</div>
            <div class="java-button java-subtitle">Netty 内存管理</div>
            <div class="java-button java-subtitle">Netty 启动原理</div>
            <div class="java-button java-subtitle">Netty之channel原理一</div>
            <div class="java-button java-subtitle">Netty编码器</div>
            <div class="java-button java-subtitle">Netty总结</div>

            <div class="java-button java-title">hotspot源码（黄俊老师）</div>

            <div class="java-button java-subtitle">​ Hotspot虚拟机原理一</div>
            <div class="java-button java-subtitle">​ Hotspot虚拟机编译环境</div>
            <div class="java-button java-subtitle">​ spu解析优化</div>
            <div class="java-button java-subtitle">​ spu架构设计和优化</div>
            <div class="java-button java-subtitle">​ Sku 性能提升</div>
            <div class="java-button java-subtitle">​ Hotspot启动原理</div>
            <div class="java-button java-subtitle">​ Hotspot启动原理</div>
            <div class="java-button java-subtitle">​ Hotspot启动原理</div>

            <div class="java-button java-title">FastDFS（张一明老师）</div>

            <div class="java-button java-subtitle">
              ​​ FastDFS 部署 原理 整合Nginx JavaAPI
            </div>
            <div class="java-button java-subtitle">
              ​​ FastDFS 集群原理 部署 缓存
            </div>
            <div class="java-button java-subtitle">
              ​​ FastDFS keepalived 高可用 zookeeper
            </div>

            <div class="java-button java-title">dubbo（张一明老师）</div>

            <div class="java-button java-subtitle">
              ​​​ dubbo demo、角色、 RPC、原理 、RMI
            </div>
            <div class="java-button java-subtitle">
              ​​​ 项目微服务拆分 注册中心、dubbo admin
            </div>
            <div class="java-button java-subtitle">
              ​​​ dubbo下的微信公众号项目 一
            </div>
            <div class="java-button java-subtitle">
              ​​​ dubbo下的微信公众号项目 二
            </div>
            <div class="java-button java-subtitle">
              ​​​ RestFul风格API、swagger API
            </div>
            <div class="java-button java-subtitle">
              ​​​ dubbo核心配置 聚合项目构建
            </div>

            <div class="java-button java-title">ElasticSearch（吴磊老师）</div>

            <div class="java-button java-subtitle">
              ​​​​ Elasticsearch核心概念
            </div>
            <div class="java-button java-subtitle">
              ​​​​ ES环境安装、健康值检查以及CRUD
            </div>
            <div class="java-button java-subtitle">
              ​​​​ 上机实战演练：ES查询语法
            </div>
            <div class="java-button java-subtitle">​​​​ Mapping和聚合查询</div>
            <div class="java-button java-subtitle">
              ​​​​ ES查询之底层原理揭秘
            </div>
            <div class="java-button java-subtitle">
              ​​​​ ES查询之Scripting查询
            </div>
            <div class="java-button java-subtitle">​​​​ ES查询之分词器详解</div>
            <div class="java-button java-subtitle">
              ​​​​ ES查询之前缀搜索、通配符搜索、正则搜索、模糊查询串讲
            </div>
            <div class="java-button java-subtitle">​​​​ ES Java API</div>
            <div class="java-button java-subtitle">​​​​ ES Java API</div>
            <div class="java-button java-subtitle">​​​​ ELK Stack-ES集群</div>
            <div class="java-button java-subtitle">​​​​ ELK Stack-ES集群</div>
            <div class="java-button java-subtitle">
              ​​​​ ELK-Beats&Logstash介绍
            </div>
            <div class="java-button java-subtitle">
              ​​​​ ELK-Lostash架构实战
            </div>
            <div class="java-button java-subtitle">
              ​​​​ ELK-收集Nginx日志，syslog，kibana讲解
            </div>
            <div class="java-button java-subtitle">
              ​​​​ ELK-使用Packetbeat监控es集群
            </div>
            <div class="java-button java-subtitle">
              ​​​​ relevance score原理及排序算法优化
            </div>
            <div class="java-button java-subtitle">
              ​​​​ ES高级查询-Nested query、Join query及Term vector详解
            </div>
            <div class="java-button java-subtitle">
              ​​​​ ES进阶-Highlight及Suggest搜索推荐详解
            </div>
            <div class="java-button java-subtitle">
              ​​​​ ES进阶-深入探秘基于地理位置搜索
            </div>

            <div class="java-button java-title">区块链（张一明老师）</div>
            <div class="java-button java-subtitle">
              区块链-比特币、挖矿、炒币原理(1)
            </div>
            <div class="java-button java-subtitle">
              区块链-比特币、挖矿、炒币原理(2)
            </div>
            <div class="java-button java-subtitle">区块链-以太坊原理</div>
            <div class="java-button java-subtitle">
              区块链-幽灵协议，pow，pos
            </div>
            <div class="java-button java-subtitle">
              区块链-DPOS共识协议，solidity智能合约开发
            </div>
            <div class="java-button java-subtitle">
              区块链-solidity手写加密货币
            </div>

            <div class="java-button title-empty java-title">
              Spring源码（连鹏举老师）
            </div>
            <div class="java-button title-empty java-title">
              SpringMVC源码（连鹏举老师）
            </div>
            <div class="java-button title-empty java-title">
              Mybatis源码（连鹏举老师）
            </div>
            <div class="java-button java-title">
              Springboot源码（连鹏举老师）
            </div>

            <div class="java-button java-subtitle">
              springboot启动源码解析一
            </div>
            <div class="java-button java-subtitle">
              springboot启动源码解析二
            </div>
            <div class="java-button java-subtitle">
              springboot启动源码解析三
            </div>
            <div class="java-button java-subtitle">
              springboot自动装配源码解析
            </div>
            <div class="java-button java-subtitle">
              springboot与tomcat整合源码解析
            </div>
            <!-- 
                        <div class="java-button java-title">SpringCloud源码（未定）
                        </div> -->
            <div class="java-button java-title">mycat（连鹏举老师）</div>

            <div class="java-button java-subtitle">mycat深度讲解01</div>
            <div class="java-button java-subtitle">mycat深度讲解02</div>
            <div class="java-button java-subtitle">mycat深度讲解03</div>
            <div class="java-button java-subtitle">mycat深度讲解04</div>
            <div class="java-button java-subtitle">mycat深度讲解05</div>
            <div class="java-button java-subtitle">mycat深度讲解06</div>
            <div class="java-button java-subtitle">mycat深度讲解07</div>
            <div class="java-button java-subtitle">mycat深度讲解08</div>

            <div class="java-button java-title">
              shardingsphere（连鹏举老师）
            </div>
            <div class="java-button java-subtitle">
              shardingsphere深度讲解01
            </div>
            <div class="java-button title-empty java-title">
              shiro（京东孙老师）
            </div>

            <div class="java-button title-empty java-title">
              游戏前端开发（海江老师）
            </div>

            <div class="java-button title-empty java-title">
              activiti（京东孙老师）
            </div>

            <div class="java-button title-empty java-title">google面试真题</div>
            <div class="java-button title-empty java-title">kafka</div>
            <div class="java-button title-empty java-title">
              架构师高级技能kubernetes入门到精通（京东齐老师）
            </div>
            <div class="java-button title-empty java-title">
              架构师必备技能docker入门到专精（京东齐老师）
            </div>
            <div class="java-button title-empty java-title">
              java日志框架-SLF4J（马士兵老师）
            </div>
            <div class="java-button title-empty java-title">
              java响应式编程（马士兵老师）
            </div>
            <div class="java-button title-empty java-title">
              数据结构和算法（马士兵老师）
            </div>
            <div class="java-button title-empty java-title">
              简明JDBC教程（马士兵老师）
            </div>
            <div class="java-button title-empty java-title">
              抽丝剥茧设计模式（马士兵老师）
            </div>
            <div class="java-button title-empty java-title">
              马老师坦克大战（马士兵老师）
            </div>

            <div class="java-button java-title">
              马老师面试指导课（马士兵老师）
            </div>
            <div class="java-button java-subtitle">硬技能之上的软技巧1</div>
            <div class="java-button java-subtitle">硬技能之上的软技巧2</div>
            <div class="java-button java-subtitle">硬技能之上的软技巧3</div>

            <div class="java-button java-title">
              英雄传说网游服务器（海江老师） 第一版
            </div>
            <div class="java-button java-subtitle">创建 Netty 服务器</div>
            <div class="java-button java-subtitle">Protobuf 消息应用</div>
            <div class="java-button java-subtitle">重构，设计模式实战</div>
            <div class="java-button java-subtitle">
              通过 Javassist 提升反射效率
            </div>
            <div class="java-button java-subtitle">重新设计移动消息</div>
            <div class="java-button java-subtitle">
              游戏服务器中的单线程设计
            </div>
            <div class="java-button java-subtitle">多线程读写数据库</div>
            <div class="java-button java-subtitle">
              利用RocketMQ 实现简单的排行榜
            </div>
            <div class="java-button java-subtitle">游戏服务器的部署</div>

            <div class="java-button java-title">
              英雄传说网游服务器（海江老师） 第二版
            </div>
            <div class="java-button java-subtitle">创建第一个游戏服务器</div>
            <div class="java-button java-subtitle">Protobuf消息应用</div>
            <div class="java-button java-subtitle">
              别急，先重构！设计模式实战
            </div>
            <div class="java-button java-subtitle">反射的终级实战</div>
            <div class="java-button java-subtitle">重新设计移动消息</div>
            <div class="java-button java-subtitle">单线程设计</div>
            <div class="java-button java-subtitle">多线程设计</div>
            <div class="java-button java-subtitle">排行榜功能实现</div>
            <div class="java-button java-subtitle">游戏服务器的部署</div>

            <div class="java-button java-title">
              网约车项目（晁鹏飞老师） 第二版
            </div>
            <div class="java-button java-subtitle">
              Spring Cloud微服务概述，注册中心搭建
            </div>
            <div class="java-button java-subtitle">Eureka 原理和源码</div>
            <div class="java-button java-subtitle">
              Eureka 配置和 服务间调用方式
            </div>
            <div class="java-button java-subtitle">Ribbon负载均衡</div>
            <div class="java-button java-subtitle">Feign声明式调用</div>
            <div class="java-button java-subtitle">Hystrix熔断降级</div>
            <div class="java-button java-subtitle">Hystrix熔断原理源码</div>
            <div class="java-button java-subtitle">网关Zuul的使用</div>
            <div class="java-button java-subtitle">网关原理源码</div>
            <div class="java-button java-subtitle">配置中心使用原理源码</div>
            <div class="java-button java-subtitle">链路追踪，监控检查</div>
            <div class="java-button java-subtitle">分布式锁</div>
            <div class="java-button java-subtitle">分布式事务</div>

            <div class="java-button java-title">
              网约车项目（晁鹏飞老师） 第三版
            </div>
            <div class="java-button java-subtitle">
              项目概述-项目启动-人员安排-需求分析（乘客端、司机端、BOSS端）-设计原则
            </div>
            <div class="java-button java-subtitle">
              服务如何拆分-接口层设计-能力层设计-基础层设计-公共模块设计-第三方技术-接口设计-接口安全
            </div>
            <div class="java-button java-subtitle">
              单体项目工程设计-异常处理-Spring
              Cloud技术架构图-网约车业务架构图-注册中心搭建-eureka生产优化（自我保护测算，三级缓存）
            </div>
            <div class="java-button java-subtitle">
              eureka生产优化（CAP方面优化：缓存、注册表拉取、网络抖动时注册表处理方案）
            </div>
            <div class="java-button java-subtitle">
              eureka生产优化（eureka
              客户端优化：心跳、拉取注册表、状态监听注册）
            </div>
            <div class="java-button java-subtitle">网约车注册中心总结</div>
            <div class="java-button java-subtitle">
              网约车乘客登录/注册
              业务分析-乘客端时序图-接口设计-QPS提升方法（提升并发数的4个方法）
            </div>
            <div class="java-button java-subtitle">
              maven版本-QPS提升方法（减少响应时间的6个方法）
            </div>
            <div class="java-button java-subtitle">
              网约车计价业务分析-预估价格-结算价格-接口时序图（5个服务的交互：乘客端服务、乘客用户服务、订单服务、计价服务、地图服务）-接口设计-计价类图设计
            </div>
            <div class="java-button java-subtitle">
              网约车派单业务分析-派单时序图（3个服务的交互：乘客端服务、派单服务、地图服务）-接口设计-派单类图设计
            </div>
            <div class="java-button java-subtitle">
              网约车司机听单业务分析-消息推送方案- 司机接受 派发的订单-
              订单状态流转
            </div>
            <div class="java-button java-subtitle">
              网约车支付业务分析-支付流程时序图-微信和支付宝整合方案-生产中灰度发布场景介绍
            </div>
            <div class="java-button java-subtitle">
              蓝绿发布-滚动发布-A/B 测算-灰度发布-网关灰度发布落地实战
            </div>
            <div class="java-button java-subtitle">
              灰度发布-ribbon落地实战-常用灰度发布框架使用
            </div>
            <div class="java-button java-subtitle">
              面试中如何写项目职责-传统项目向微服务改造的问题（网关敏感信息被过滤的原理分析及解决方案）
            </div>
            <div class="java-button java-subtitle">
              网关zuul的原理介绍-网关源码跟踪-过滤器的来龙去脉-解决实际问题思路分析
            </div>
            <div class="java-button java-subtitle">
              网关中经典动态路由问题解决的2种方案（通过服务转发，通过url路径转发）
            </div>

            <div class="java-button title-empty java-title">TDD最佳实践</div>
            <div class="java-button java-title">SpringCloud（张一明老师）</div>

            <div class="java-button java-subtitle">
              开班典礼-从单机到微服务架构演化
            </div>
            <div class="java-button java-subtitle">
              SpringCloud 全家桶所有组 需求拆解 HttpDns 二级域名 CDN系统
            </div>
            <div class="java-button java-subtitle">
              Eureka 注册中心 高可用 远程服务调用
            </div>
            <div class="java-button java-subtitle">
              Ribbon 客户端的负载均衡 服务手动上下线
            </div>
            <div class="java-button java-subtitle">
              Rest API Resttemplate Feign 原生与面向接口调用
            </div>
            <div class="java-button java-subtitle">
              Feign的负载均衡、重试机制 手动实现 Hystrix 降级、熔断、隔离
            </div>
            <div class="java-button java-subtitle">
              Feign、RestTemplate、Dashboard 整合hystrix 信号量与线程池
            </div>
            <div class="java-button java-subtitle">
              Zuul 网关 Sleuth+zipkin链路追踪 Admin健康检查 邮件、钉钉群通知
            </div>
            <div class="java-button java-subtitle">
              SpringCloud Config 什么是配置中心及应用场景 Config + GitHub
              配置命名规则 分支读取 加载远程配置 微服务手动刷新与自动刷新配置
            </div>
            <div class="java-button java-subtitle">
              Session与Cookies&Token 浏览器同源策略与跨域 Shiro Spring security
              SSO CSRF、xss攻击原理
            </div>
            <div class="java-button java-subtitle">
              SpringSecurity 自定义登录页面 CSRF 解决方案 密码加密算法的演化过程
            </div>
            <div class="java-button java-subtitle">
              SpringSecurity 用户内存、jdbc存储
              Security中的UserDetails与数据库中的字段 忽略静态请求
              如何使用mybatis、jpa查询用户 自定义用户权限校验 Remember Me
              功能实现 同一用户多地点登录、禁止其他终端登录 Ant 风格路径表达式
            </div>
            <div class="java-button java-subtitle">
              SpringSecurity
              验证码、权限继承、防火墙与Sql注入、实现注销登录、退出控制器
              登录成功、失败
              控制器、基于角色的权限控制与继承、细粒度注解方式方法级权限控制、自定义前置Filter
              及图形验证码
            </div>
            <div class="java-button java-subtitle">
              微服务集群 会话管理什么是SSO 有状态会话与无状态会话
              集群化Session共享 SpringSession + Redis JWT原理 JWT
              在微服务中的应用
            </div>
            <div class="java-button java-subtitle">
              使用 JWT 替换SpringSecurity Session认证 JTW Token 在浏览器、App
              如何防止重放攻击 OAuth2.0认证服务器资源服务器 与第三方服务实现
            </div>
            <div class="java-button java-subtitle">
              HTTPS原理 四次握手 数据究竟会不会被偷窥
            </div>
            <div class="java-button java-subtitle">
              OPenSSL证书生成以及自签名证书、自建CA、Nginx如何配置HTTPS、让自签名证书也能让系统信任、购买线上服务器、线上服务器域名解析、线上服务器SSL免费证书申请及认证过程
            </div>
            <div class="java-button java-subtitle">
              什么是响应式web 异步调用 callback的本质 servlet3的异步
              业务线程的异步
            </div>
            <div class="java-button java-subtitle">
              SSE实现 响应式和阻塞式的微服务内部与web端 响应式特点 背压的概念
            </div>
            <div class="java-button java-subtitle">
              服务调用中的三种耦合 响应式中的流量控制 RXJava2
              观察者模式同步与异步实现 Project Reactor 中的Flux、Mono
            </div>
            <div class="java-button java-subtitle">
              使用Netty作为web容器 基于注解的WebFlux阻塞式与响应式实现 WebFlux +
              SSE 服务器推 WebFlux中的ServerHttpRequest 与SpringMVC的区别
            </div>

            <div class="java-button java-title">
              P8课程最佳实践（周志垒老师，黄俊老师，李彦良老师）
            </div>
            <div class="java-button java-subtitle">
              架构师基础理论及架构演变史
            </div>
            <div class="java-button java-subtitle">
              分布式锁前置技能-etcd集群环境搭建
            </div>
            <div class="java-button java-subtitle">多种分布式锁实现</div>
            <div class="java-button java-subtitle">Redis集群与ZK集群搭建</div>
            <div class="java-button java-subtitle">分布式id原理</div>
            <div class="java-button java-subtitle">Redis集群和ES安装配置</div>
            <div class="java-button java-subtitle">美团leaf源码分析</div>
            <div class="java-button java-subtitle">P8架构师全景概论</div>
            <div class="java-button java-subtitle">电商架构概览</div>

            <div class="java-button java-subtitle">
              P8集群canal中间件安装与配置
            </div>
            <div class="java-button java-subtitle">Leaf源码与优化方案</div>
            <div class="java-button java-subtitle">
              P8-Spring 微服务CI CD（一）
            </div>
            <div class="java-button java-subtitle">Canal源码深度剖析（一）</div>
            <div class="java-button java-subtitle">
              P8架构师全景概论之通信篇
            </div>
            <div class="java-button java-subtitle">
              P8-Spring 微服务CI CD（二）
            </div>
            <div class="java-button java-subtitle">Canal源码深度剖析（二）</div>
            <div class="java-button java-subtitle">
              P8-Spring 微服务CI CD（三）
            </div>
            <div class="java-button java-subtitle">Canal源码深度剖析（三）</div>
            <div class="java-button java-subtitle">
              P8-Spring 微服务CI CD（四）
            </div>

            <div class="java-button title-empty java-title">
              分布式事务（晁鹏飞老师）
            </div>
            <div class="java-button title-empty java-title">分布式锁</div>
            <div class="java-button title-empty java-title">
              mongoDB精讲（连鹏举老师）
            </div>
            <div class="java-button title-empty java-title">
              科技英语课（echo老师）
            </div>
          </div>
        </div>

        <div class="course-pic-list" style="padding-top: 0">
          <img
            src="//mashibing.com/mcaImage/5f87c2fa08e28a4c00000000.jpg"
            alt=""
          />

          <img
            src="//mashibing.com/mcaImage/5dc3857b084d029c07501288.jpg"
            alt=""
          />

          <img
            src="//mashibing.com/mcaImage/5dae9dbf08a1ca5e07501308.jpg"
            alt=""
          />

          <img
            src="//mashibing.com/mcaImage/5dae9dcd08ef3d5807501264.jpg"
            alt=""
          />

          <img
            src="//mashibing.com/mcaImage/5dae9dd7080198af07501268.jpg"
            alt=""
          />

          <img
            src="//mashibing.com/mcaImage/5dae9de208e9234507501288.jpg"
            alt=""
          />

          <img
            src="//mashibing.com/mcaImage/5dae9df2081ba7ef07501084.jpg"
            alt=""
          />

          <div>
            <courseSystem2 />
          </div>

          <img
            src="//mashibing.com/mcaImage/5db966550836def007501112.jpg"
            alt=""
          />

          <img
            src="//mashibing.com/mcaImage/5db7ebac087ffccb07501008.jpg"
            alt=""
          />

          <img
            src="//mashibing.com/mcaImage/5db7ebac087f11bd07500820.jpg"
            alt=""
          />
        </div>

        <div class="plan-type-list" id="courseList">
          <div class="week_content_container">
            <h2 class="main_title">一份周密的学习计划<br />成就优秀的你</h2>
            <h4>细化到以周为单位的学习进度<br />学练结合，技术难点逐一击破</h4>
            <div class="week_wrapper">
              <h4 data-index="1" class="step_title js-fold-trigger highlight">
                <span>阶段一：</span> 单体电商项目架构，开发与上线（1~5）
              </h4>

              <div class="step_content js-fold-content active">
                <ul class="week_title">
                  <li class="js-tablist-trigger active" data-index="1">1</li>
                  <li class="js-tablist-trigger" data-index="2">2</li>
                  <li class="js-tablist-trigger" data-index="3">3</li>
                  <li class="js-tablist-trigger" data-index="4">4</li>
                  <li class="js-tablist-trigger" data-index="5">5</li>
                  <li class="js-tablist-trigger" data-index="6">提高篇</li>
                </ul>
                <div class="week_content">
                  <div
                    class="content_hide js-tablist-content"
                    style="display: block"
                  >
                    <h6 class="content_title">万丈高楼，地基首要</h6>
                    <p class="content_default_text">
                      在开始系统化成长之初，先从整体上认知大型互联网系统架构演变历程，
                      明确架构师需要具备哪些技术栈与核心能力，之后开始筑基-单体开发。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>大型互联网系统架构演变历程</li>
                      <li>Java架构师需要具备的技术栈与能力</li>
                      <li>项目演示与单体架构技术选型</li>
                      <li>前后端分离开发模式与项目分层设计原则</li>
                      <li>聚合工程构建与SpringBoot2.1.x结合</li>
                      <li>基于PowerDesigner工具为数据库建模</li>
                      <li>整合HikariCP与Druid，及其原理讲解</li>
                      <li>MyBatis数据库逆向生成与原理讲解</li>
                      <li>Mybatis-plus整合与使用</li>
                      <li>Mybatis-plus原理讲解</li>
                      <li>事务传播详解，spring事务，数据库事务原理</li>
                      <li>用户注册/登录流程详解与功能开发</li>
                      <li>API文档生成工具Swagger2与knife4j</li>
                      <li>设置跨域配置实现前后端联调</li>
                      <li>整合Log4j打印日志</li>
                      <li>通过日志监控接入ELK</li>
                      <li>用户JWT统一认证</li>
                      <li>实现SSO单点登录</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">
                      分类，推荐，搜索，评价，购物车开发
                    </h6>
                    <p class="content_default_text">
                      本周首先带大家分析电商首页需求，然后实现分类功能，商品推荐功能，搜索功能，商品评价功能，最后带大家开发电商核心功能模块-购物车。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>电商技术栈概要介绍</li>
                      <li>Maven与Gradle讲解</li>
                      <li>基于MongoDB与MySQL数据库设计表</li>
                      <li>分类实现 - 分类树设计与实现</li>
                      <li>商品推荐模块实现</li>
                      <li>基于用户画像进行商品推荐</li>
                      <li>搜索商品</li>
                      <li>基于倒排索引的Elasticsearch，优化商品搜索</li>
                      <li>商品搜索纠错</li>
                      <li>商品搜索关联</li>
                      <li>商品评价模块实现</li>
                      <li>使用自然语言处理NLP，对评论数据脱敏清洗</li>
                      <li>购物车 - 购物车存储形式</li>
                      <li>购物车 - 未登录已登录加入购物车业务代码讲解</li>
                      <li>购物车 - 删除商品业务讲解</li>
                      <li>购物车优化，基于redis实现购物车</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">
                      地址，订单，支付，定时任务开发
                    </h6>
                    <p class="content_default_text">
                      本周首先带大家完成收获地址的开发，接着开发电商核心业务功能-订单，支付（微信支付，支付宝支付），最后带大家设计一个定时任务，实现定时关闭超期未支付订单功能。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>收货地址实现</li>
                      <li>订单模块实现</li>
                      <li>微信支付 - 构建商户端支付成功的回调接口</li>
                      <li>微信支付 - 生成支付二维码</li>
                      <li>微信支付 - 商户回调地址与内网穿透</li>
                      <li>支付宝支付 - 异步通知与同步通知</li>
                      <li>定时任务 - 定时关闭超期未支付订单</li>
                      <li>定时任务 - 定时任务弊端与优化方案</li>
                      <li>
                        定时任务中间件，原理讲解
                        <p>
                          - quartz <br />
                          - Spring Scheduler <br />
                          - xxl-job <br />
                          - Elastic-Job
                        </p>
                      </li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">用户中心 ,订单/评价管理开发</h6>
                    <p class="content_default_text">
                      本周首先带大家完成用户中心模块，之后一起完成订单管理，评价管理功能，完善中心首页，
                      通过本周的学习，我们已经完全有能力架构与开发任何一个单体的项目了。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>引入mybatis-plus，避免手动编写sql</li>
                      <li>mybatis-plus原理讲解</li>
                      <li>用户模块实现</li>
                      <li>评价管理模块实现</li>
                      <li>中心首页模块编写</li>
                      <li>促销模块实现</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">云服务器部署上线</h6>
                    <p class="content_default_text">
                      本周带大家一起打包与发布前端项目，后端项目到云服务器上，最后让大家拥有一个上线电商项目。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>
                        云服务器购买及安装配置(JDK/Tomcat/MariaDB/MySQL/MongoDB)
                      </li>
                      <li>xshell工具使用</li>
                      <li>Linux操作系统指令讲解</li>
                      <li>SpringBoot多环境部署profile(开发环境/生产环境)</li>
                      <li>SpringBoot项目打成war并发布到云服务器</li>
                      <li>前端项目发布</li>
                      <li>测试电商整体流程</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>剖析原理解读源码之Spring Core</li>
                      <li>剖析原理解读源码之SpringMVC</li>
                      <p>
                        - AOP面向切面原理解析 <br />
                        - IOC控制反转原理解析 <br />
                        - DI依赖注入原理解析 <br />
                      </p>

                      <li>剖析原理解读源码之MyBatis</li>
                      <li>剖析原理解读源码之Tomcat</li>
                      <p>
                        - 整体架构 <br />
                        - 启动流程 <br />
                        - 线程模型 <br />
                        - IO处理流程 <br />
                        - 热部署与热加载 <br />
                      </p>
                      <li>剖析原理解读源码之SpringBoot</li>
                      <p>
                        - springboot启动源码解析 <br />
                        - springboot自动装配源码解析 <br />
                        - springboot与tomcat整合源码解析 <br />
                      </p>
                      <li>剖析原理解读源码之SpringCloud核心</li>
                    </ol>
                  </div>
                </div>
              </div>

              <div class="step_title js-fold-trigger" data-index="2">
                <span>阶段二：</span> 从单体到高可用集群演进（6-8）
              </div>
              <div class="step_content js-fold-content">
                <ul class="week_title">
                  <li class="js-tablist-trigger active" data-index="1">6</li>
                  <li class="js-tablist-trigger" data-index="2">7</li>
                  <li class="js-tablist-trigger" data-index="3">8</li>
                  <li class="js-tablist-trigger" data-index="4">秒杀系统</li>
                  <li class="js-tablist-trigger" data-index="5">进阶篇</li>
                </ul>

                <div class="week_content">
                  <div
                    class="content_hide js-tablist-content"
                    style="display: block"
                  >
                    <h6 class="content_title">
                      LVS+Nginx+Tengine实现高可用集群
                    </h6>
                    <p class="content_default_text">
                      本周开始，我将从单体演进到集群，首先带大家学习Nginx，负载均衡等相关技术，之后带大家通过LVS+Keepalived+Nginx实现高可用服务器集群，
                      从而降低单节点负载压力。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>Nginx原理讲解</li>
                      <li>lua语言讲解</li>
                      <li>Nginx中lua脚本使用</li>
                      <li>openrester介绍</li>
                      <li>在Nginx中解决跨域问题</li>
                      <li>在Nginx中配置静态资源防盗链</li>
                      <li>Nginx模块化设计</li>
                      <li>Nginx集群负载均衡</li>
                      <li>使用Nginx搭建3台Tomcat集群</li>
                      <li>使用JMeter测试单节点与集群并发异常率</li>
                      <li>使用 Keepalived提高吞吐量</li>
                      <li>
                        负载均衡原理剖析 - ip_hash - url hash 与 least_conn
                      </li>
                      <li>一致性hash算法讲解</li>
                      <li>Nginx控制浏览器缓存</li>
                      <li>Nginx反向代理缓存</li>
                      <li>使用Nginx配置SSL证书提供HTTPS访问</li>
                      <li>Nginx单实例存在的问题与集群原理详解</li>
                      <li>心跳机制与自动重启实现</li>
                      <li>动静分离的那些事儿</li>
                      <li>部署Nginx到云端 - 实现动静分离与虚拟主机</li>
                      <li>部署Nginx到云端 - 测试与日志调试</li>
                      <li>实现Keepalived高可用双机主备</li>
                      <li>实现Keepalived高可用双机热备</li>
                      <li>LVS+Keepalived+Nginx实现高可用集群 负载均衡</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">主从复制高可用Redis集群</h6>
                    <p class="content_default_text">
                      本周首先会对Redis的架构与原理进行解析，之后整合Redis,实现Redis哨兵,搭建主从复制高可用Redis集群等，最后带大家解决缓存雪崩，穿透等问题。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>单机Redis架构介绍</li>
                      <li>Redis与Memcached 对比与区别</li>
                      <li>Redis源码详解，一个请求接收到处理流程</li>
                      <li>Redis数据结构底层实现讲解</li>
                      <li>在SpringBoot中整合Redis实现数据存取</li>
                      <li>基于Redis优化首页轮播图和分类查询</li>
                      <li>在Redis中实现订阅功能</li>
                      <li>Redis中RDB,AOF持久化工作原理解析</li>
                      <li>Redis集群架构介绍</li>
                      <li>Redis主从架构模式讲解</li>
                      <li>Redis主从复制,无磁盘化复制原理解析</li>
                      <li>过期的缓存Key处理方案</li>
                      <li>Redis哨兵机制与原理解析</li>
                      <li>Redis哨兵落地实现</li>
                      <li>Redis Cluster解决方案设计</li>
                      <li>Redis Cluster原理解析</li>
                      <li>codis 架构与源码解析</li>
                      <li>Raft协议讲解</li>
                      <li>Redis使用的Gossip分布式一致性协议详解</li>
                      <li>主从复制高可用Redis集群搭建</li>
                      <li>SpringBoot集成Redis集群环境</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">Redis缓存雪崩，穿透，击穿</h6>
                    <p class="content_default_text">
                      本周会帮大家分析缓存雪崩现象，然后为大家讲解缓存雪崩的解决方案，缓存穿透的解决方案，并且带大家一起落地解决对应的问题，最后为家拓展讲解Redis批量查询的优化设计。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>缓存雪崩，穿透，击穿现象解析</li>
                      <li>缓存雪崩的解决方案与落地</li>
                      <li>缓存穿透的解决方案与落地</li>
                      <li>拔高-Redis批量查询原理</li>
                      <li>拔高-管道（pipeline）的使用</li>
                      <li>拔高-Redis批量查询的优化设计</li>
                    </ol>
                  </div>

                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">商城秒杀系统</h6>
                    <p class="content_default_text">
                      秒杀系统一般是业务中并发量最大的系统，需要考虑最多的问题。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>如何处理瞬时大流量高并发</li>
                      <li>如何处理有限库存，不能超卖</li>
                      <li>如何不影响其他业务，保证服务的高可用</li>
                      <li>如何处理商品限购</li>
                      <li>如何处理黑客恶意请求</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">剖析原理解读源码之Netty</h6>
                    <ol>
                      <li>Java NIO</li>
                      - Channel
                      <br />
                      - Buffer
                      <br />
                      - Selector
                      <br />
                      <li>Netty网络模型</li>
                      - Reactor模型
                      <br />
                      <li>Netty核心组件</li>
                      - Bootstrap & ServerBootstrap
                      <br />
                      - Channel
                      <br />
                      - ChannelFuture
                      <br />
                      - EventLoop & EventLoopGroup
                      <br />
                      - ChannelHandler
                      <br />
                      - ChannelPipeline
                      <br />
                      <li>Netty之内存管理</li>

                      <li>Netty编码器</li>

                      <li>Netty总结</li>
                    </ol>
                  </div>
                </div>
              </div>
              <div class="step_title js-fold-trigger" data-index="3">
                <span>阶段三：</span>
                分布式架构-逐个击破分布式核心问题（9-22）
              </div>
              <div class="step_content js-fold-content">
                <div class="hide_scroll_bar js-fold-weeklist">
                  <div
                    class="scroll_arrow imv2-arrow2_u js-scroll-trigger disabled"
                    data-direction="-1"
                  ></div>
                  <div class="scroll_target_container js-scroll-target">
                    <ul class="week_title">
                      <li class="js-tablist-trigger active" data-index="1">
                        导论篇
                      </li>
                      <li class="js-tablist-trigger" data-index="2">9</li>
                      <li class="js-tablist-trigger" data-index="3">10</li>
                      <li class="js-tablist-trigger" data-index="4">11</li>
                      <li class="js-tablist-trigger" data-index="5">12</li>
                      <li class="js-tablist-trigger" data-index="6">13</li>
                      <li class="js-tablist-trigger" data-index="7">14</li>
                      <li class="js-tablist-trigger" data-index="8">15</li>
                      <li class="js-tablist-trigger" data-index="9">16</li>
                      <li class="js-tablist-trigger" data-index="10">17</li>
                      <li class="js-tablist-trigger" data-index="11">18</li>
                      <li class="js-tablist-trigger" data-index="12">19</li>
                      <li class="js-tablist-trigger" data-index="13">20</li>
                      <li class="js-tablist-trigger" data-index="14">21</li>
                      <li class="js-tablist-trigger" data-index="15">22</li>
                    </ul>
                  </div>
                  <div
                    class="scroll_arrow imv2-arrow2_d js-scroll-trigger"
                    data-direction="1"
                  ></div>
                </div>
                <div class="week_content">
                  <div
                    class="content_hide js-tablist-content"
                    style="display: block"
                  >
                    <h6 class="content_title">导论-从单体到微服务系统架构</h6>
                    <ol>
                      <li>从单机到微服务架构演化</li>
                      <li>单台数据库的QPS，单台Redis的QPS</li>
                      <li>适用于创业型的单体应用如何做到快速开发快速交付</li>
                      <li>最小原型设计原则、小步快跑、可落地的敏捷开发</li>
                      <li>成本与风险之间的杠杆：企业到底该不该使用云服务</li>
                      <li>降低软件复杂性的原则和方法</li>
                      <li>如何把单体应用中的数据库和Tomcat、Jvm调优到极致</li>
                      <li>瞬间提供百倍并发，深度剖析淘宝动静分离架构</li>
                      <li>淘宝网初期对数据源的调优策略与热点缓存设计</li>
                      <li>淘宝初期数据库分库分表架构策略</li>
                      <li>
                        企业级集群化服务：如何正确预估服务用量和单节点服务器CPU、内存、网卡、网络带宽预算清单
                      </li>
                      <li>集群化服务</li>
                      1. 企业级集群化服务：架构方案带来的生产环境中的痛点
                      <br />
                      2.
                      企业级集群化服务：深度剖析几种负载均衡器底层原理与技术选型<br />
                      3. 用户权限会话在分布式系统高并发场景下的架构设计<br />
                      <li>微服务</li>
                      1. 微服务前生今世<br />
                      2. 微服务如何对大型项目解耦<br />
                      3. 如果让我设一套微服务框架，我该怎么做？<br />
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">分布式系统理论</h6>
                    <ol>
                      <li>分布式理论的地基：CAP定理</li>
                      <li>
                        阿里技术团队也无力，12306服务不可用的魔咒究竟能否打破
                      </li>
                      <li>
                        深度讲解Redis、Zookeeper、Eureka等开源项目对CAP的取舍
                      </li>
                      <li>
                        数据一致性（强一致性 - 弱一致性 - 最终一致性 ）、可用性
                      </li>
                      <li>淘宝网如何做到 SLA 6个9以上的高可用服务</li>
                      <li>透彻解读AP下保持事务最终一致性：BASE</li>
                      <li>互联网企业架构中的1秒法则</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">集群环境下用户登录</h6>
                    <ol>
                      <li>有状态会话和无状态会话区别</li>
                      <li>动静分离架构下的用户会话解决方案</li>
                      <li>集群与分布式系统中的用户会话解决方案</li>
                      <li>单个Tomcat会话和全局Redis会话关系</li>
                      <li>通过Redis+Cookie来实现前后端分离与分布式会话</li>
                      <li>配置用户权限拦截器</li>
                      <li>单点登录的作用，为何使用SSO</li>
                      <li>多系统跨域的用户会话问题</li>
                      <li>常见的会话跨域形式（Session 共享）</li>
                      <li>Cookie实现Session跨域与原理</li>
                      <li>spring-session实现与原理</li>
                      <li>有状态会话，无状态会话</li>
                      <li>JWT（JSON Web Token）方案实现单点登录</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">分布式搜索引擎-ES</h6>
                    <p class="content_default_text">
                      本周我们首先会以架构师角度分析目前搜索业务的弊端，之后由浅入深讲解ES，集成ES集群，优化商品搜索与分类搜索等功能，最后拓展2个案例让大家更加深入的理解ES。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>倒排索引介绍</li>
                      <li>ES架构与原理解析</li>
                      <li>ES核心包，Lucene原理解析</li>
                      <li>ES健康状况详解</li>
                      <li>IK，HanLP分词插件，词库与原理</li>
                      <li>dsl搜索(分页，多关键字匹配，布尔查询)</li>
                      <li>出现不合法搜索如何定位问题</li>
                      <li>ES集群原理，shard与replica</li>
                      <li>集成ES集群故障之节点宕机</li>
                      <li>集成ES集群故障之脑裂问题探讨</li>
                      <li>集群环境中（分布式）文档的存取原理</li>
                      <li>MySql和ES进行数据同步的方案分析</li>
                      <li>MySQL中使用binlog，数据同步ES原理</li>
                      <li>Canal与DataLink，同步中间件原理解析</li>
                      <li>基于Logstash与FileBeats进行数据同步</li>
                      <li>引入kafka解决高流量时，log可能丢失问题</li>
                      <li>基于ES实现商品搜索与分类搜索</li>
                      <li>ES深度分页下会带来怎样的性能问题</li>
                      <li>大数据量下该如何使用Scoll滚动技术进行搜索</li>
                      <li>ES拓展 - 基于Geo的地理坐标搜索实现</li>
                      <li>ES拓展 - 社交案例，距离我几公里内的好友</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">分布式文件系统-FastDFS+OSS</h6>
                    <p class="content_default_text">
                      在分布式系统中，文件系统是必须被所有节点访问的，为了解决单体架构中文件服务的单一性问题，我们需要学习分布式文件存储（FastDFS、阿里OSS云存储，七牛云）。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>以架构师角度分析目前文件上传所存在的问题</li>
                      <li>
                        分布式文件系统基石，Google分布式文件系统（GFS）讲解
                      </li>
                      <li>分布式文件系统技术选型：FastDFS VS 阿里OSS</li>
                      <li>FastDFS架构与原理解析</li>
                      <li>Nginx + FastDFS 实现文件服务器</li>
                      <li>FastDFS整合SpringBoot，修改项目中文件上传</li>
                      <li>第三方图片存储解决方案</li>
                      <li>阿里OSS存储与实现原理</li>
                      <li>SpringBoot整合阿里OSS SDK与API</li>
                      <li>实现图片上传到OSS中</li>
                      <li>在生产环境中切换文件存储为FastDFS</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">分布式消息队列</h6>
                    <p class="content_default_text">
                      本周首先会讲解业界主流消息队列技术选型ActiveMQ、RabbitMQ、RocketMQ，提升大家的技术判断能力。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>业界主流消息队列与技术选型</li>
                      <li>ActiveMQ集群架构与原理解析</li>
                      <li>RabbitMQ集群架构与原理解析</li>
                      <li>RocketMQ集群架构与原理解析</li>
                      <li>Kafka集群架构与原理解析</li>
                      <li>
                        RocketMQ 源码分析 Consumer启动流程 长轮询 ProcessQueue
                      </li>
                      <li>RocketMQ 源码分析 MQClientInstance.start 任务调度</li>
                      <li>RocketMQ 刷盘机制源码分析 Broker启动流程 源码分析</li>
                      <li>
                        作为架构师如何去进行高层次的抽象公共API封装,消息序列化
                      </li>
                      <li>分布式定时任务组件封装</li>
                      <li>可靠性消息重试实现集成定时任务组件</li>
                      <li>批量，延迟消息应用与封装实现</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">分布式消息队列-Kafka</h6>
                    <p class="content_default_text">
                      本周我们来深入学习另外一个分布式消息队列-Kafka，然后基于Kafka搭建一个高吞吐量日志收集平台，让大家在实战中彻底掌握Kafka。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>Kafka核心API</li>
                      <li>Kafka与SpringBoot整合实战</li>
                      <li>Kafka高吞吐量-海量日志收集架构设计</li>
                      <li>Kafka高吞吐量-日志输出(Log4j2）</li>
                      <li>Kafka高吞吐量-日志收集(FileBeat）</li>
                      <li>Kafka高吞吐量-日志过滤(Logstash)</li>
                      <li>Kafka高吞吐量-日志持久化(Elasticsearch)</li>
                      <li>Kafka高吞吐量-日志可视化(Kibana)</li>
                      <li>Kafka监控告警watcher监控告警实战</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">
                      分布式锁理论以及在各种场景下的实践路线
                    </h6>
                    <p class="content_default_text">
                      在高并发场景下资源共享问题是比较常见也是必须要解决的。本周我们就学习多种基于分布式锁的解决方案，对比它们各自的优缺点，最后大家可以根据自己项目实际情况进行选择。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>如何使用锁解决电商项目产生的超卖问题？</li>
                      <li>基于Synchronized锁解决超卖问题（最原始的锁）</li>
                      <li>基于ReentrantLock锁解决超卖问题（并发包中的锁）</li>
                      <li>乐观锁与悲观锁，公平锁与非公平锁</li>
                      <li>虚拟机Hotspot中锁底层原理讲解</li>
                      <li>锁的汇编指令表示</li>
                      <li>虚拟机中锁的升级与降级</li>
                      <li>单体应用锁局限性分析&解决方案</li>
                      <li>基于数据库的悲观锁实现分布式锁</li>
                      <li>基于Redis的setnx实现分布式锁</li>
                      <li>Redlock原理详解</li>
                      <li>基于ETCD实现分布式锁</li>
                      <li>基于Zookeeper的瞬时节点实现分布式锁</li>
                      <li>基于Zookeeper的客户端Curator实现分布式锁</li>
                      <li>基于Redis的Java客户端Redisson实现分布式锁</li>
                      <li>如何在电商项目中引入Redisson分布式锁</li>
                      <li>多种分布式锁技术实现方案，如何选择?</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">MySQL读写分离、分库分表</h6>
                    <p class="content_default_text">
                      随着系统数据量的增加，单体数据库存储性能问题日益凸显，本周我们就来学习2种数据源读写分离和分库分表的解决方案-MyCAT和Sharding-JDBC。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>如何选择垂直切分、水平切分</li>
                      <li>MyCAT快速体验</li>
                      <li>MyCAT用户配置</li>
                      <li>MyCAT的schema配置实操</li>
                      <li>MySql主从配置</li>
                      <li>MyCAT分片规则配置（枚举分片、取模）</li>
                      <li>MyCAT全局表、子表</li>
                      <li>MyCAT高可用架构原理解析</li>
                      <li>MyCAT高可用架构-反向代理(HAProxy)</li>
                      <li>Sharding-JDBC分片表 （Spring和SpringBoot）</li>
                      <li>Sharding-JDBC全局表（Spring和SpringBoot）</li>
                      <li>Sharding-JDBC子表（Spring和SpringBoot）</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">分布式数据库</h6>
                    <p class="content_default_text">
                      能不能减少程序员对数据库的处理，使得数据库原生支持分布式？
                      阿里云DRDS，蚂蚁OceanBase，PingCAP的TiDB，MongoDB
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>分布式数据库原理</li>
                      <li>传统事务的基本特性（ACID）</li>
                      <li>分布式事务难点</li>
                      <li>两阶段提交方案之XA</li>
                      <li>两阶段提交方案之Seata</li>
                      <li>解决痛点之方案TCC</li>
                      <li>落地方案之可靠消息最终一致性方案</li>
                      <li>落地方案之最大努力通知方案</li>
                      <li>
                        分布式事务解决方案LCN（Lock Confirm notify）原理-实战
                      </li>
                      <li>分布式事务解决方案TCC-mysql-redis-混合实战</li>
                      <li>分布式事务解决方案Seata AT模式</li>
                      <li>分布式事务解决方案Seata-at-tcc-空回滚-幂等-悬挂</li>
                      <li>分布式事务解决方案Seata 实战</li>
                      <li>
                        分布式事务解决方案-可靠消息服务-最大努力通知-事务消息
                      </li>
                      <li>分布式数据库选型</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">
                      分布式全局ID、分布式事务和数据一致性
                    </h6>
                    <p class="content_default_text">
                      分库分表后，引发了ID重复问题、分布式事务等问题，本周我们会学习多种分布式全局ID的解决方案以及多种分布式事务的解决方案。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>分布式全局ID的多种解决方案</li>
                      <li>分布式中使用UUID存在的问题</li>
                      <li>基于MyCAT实现全局唯一主键ID（本地文件和数据库）</li>
                      <li>基于雪花算法实现全局唯一主键ID</li>
                      <li>基于segment算法，实现全局唯一主键ID</li>
                      <li>自研分布式ID生成器架构设计，与源码讲解</li>
                      <li>分布式系统CAP、BASE原理和ACID原则</li>
                      <li>分布式事务问题解析</li>
                      <li>基于XA协议的两阶段提交解决数据一致性问题</li>
                      <li>使用Atomikos做分布式事务</li>
                      <li>使用RocketMq实现分布式事务</li>
                      <li>MyCAT与Sharding-JDBC分布式事务</li>
                      <li>基于事务补偿机制解决数据一致性</li>
                      <li>基于本地消息表+定时任务解决数据一致性</li>
                      <li>基于MQ生产消费模型解决数据一致性</li>
                      <li>LCN分布式事务解决方案的原理和实现思路</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">
                      技术底层支撑之Linux，内存IO/网络IO/磁盘IO
                    </h6>
                    <ol>
                      <li>Linux系统的内存映射</li>
                      <li>磁盘存储性能高于内存存储，Kafka是如何做到的</li>
                      <li>Linux内核级讲解：异步网络IO Epoll核心解析</li>
                      <li>Linux内核级讲解：文件IO，内存映射原理</li>
                      <li>Linux内核级讲解：内核态、用户态转换</li>
                      <li>Linux内核级讲解：数据零拷贝、网卡推送</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">
                      技术底层支撑之从Socket到手写RPC框架
                    </h6>
                    <ol>
                      <li>虚拟文件系统，文件描述符，IO重定向</li>

                      <li>
                        内核中PageCache、mmap作用、java文件系统io、nio、内存中缓冲区作用
                      </li>

                      <li>Socket编程BIO及TCP参数</li>

                      <li>C10K问题及NIO精讲和IO模型性能压测</li>

                      <li>网络编程之多路复用器及Epoll精讲</li>

                      <li>网络编程java API 实战多路复用器开发</li>

                      <li>全手写急速理解Netty模型及IO模型应用实战</li>

                      <li>Netty之IO模型开发本质手写部分实现推导篇</li>

                      <li>全手写基于Netty的RPC框架自定义协议，连接池</li>

                      <li>
                        全手写基于Netty的RPC框架 协议编解码问题
                        粘包拆包与内核关系
                      </li>

                      <li>
                        全手写基于Netty的RPC框架
                        provider端简单dispatcher实现RPC调用全流程
                      </li>

                      <li>
                        全手写基于Netty的RPC框架
                        简单重构框架分层及RPC传输的本质及有无状态的RPC区别
                      </li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">技术底层支撑之多线程与高并发</h6>
                    <ol>
                      <li>
                        单机高并发应该掌握的线程基础：线程状态，异常与锁等
                      </li>

                      <li>解析自旋锁CAS操作与volatile</li>

                      <li>
                        JUC包下AtomicXXX类与新的同步机制：Latch Semaphore等
                      </li>

                      <li>
                        LockSupport，高频面试题，AQS源码，以及源码阅读方法论
                      </li>

                      <li>强软弱虚四种引用以及ThreadLocal的原理与源码</li>

                      <li>
                        线程池可用的各种高并发容器详解：CopyOnWriteList，BlockingQueue等
                      </li>

                      <li>
                        详解线程池：自定义线程池，JDK自带线程池，ForkJoin，源码解析等(一）
                      </li>

                      <li>
                        详解线程池：自定义线程池，JDK自带线程池，ForkJoin，源码解析等(二）
                      </li>

                      <li>单机压测工具JMH，单机最快MQ - Disruptor原理解析</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">技术底层支撑之JVM调优</h6>
                    <ol>
                      <li>JVM入门级class文件格式</li>

                      <li>详解Class加载过程</li>

                      <li>Java内存模型</li>

                      <li>内存屏障与JVM指令</li>

                      <li>Java运行时数据区和常用指令</li>

                      <li>JVM调优必备理论知识-GC Collector-三色标记</li>

                      <li>JVM调优实战</li>

                      <li>JVM实战调优</li>

                      <li>垃圾回收算法串讲</li>

                      <li>JVM常见参数总结</li>

                      <li>Java内存模型</li>
                    </ol>
                  </div>
                </div>
              </div>
              <div class="step_title js-fold-trigger" data-index="4">
                <span>阶段四：</span> 改造微服务（23-31）
              </div>
              <div class="step_content js-fold-content">
                <div class="hide_scroll_bar js-fold-weeklist">
                  <div
                    class="scroll_arrow imv2-arrow2_u js-scroll-trigger disabled"
                    data-direction="-1"
                  ></div>
                  <div class="scroll_target_container js-scroll-target">
                    <ul class="week_title">
                      <li class="js-tablist-trigger active" data-index="1">
                        23
                      </li>
                      <li class="js-tablist-trigger" data-index="2">24</li>
                      <li class="js-tablist-trigger" data-index="3">25</li>
                      <li class="js-tablist-trigger" data-index="4">26</li>
                      <li class="js-tablist-trigger" data-index="5">27</li>
                      <li class="js-tablist-trigger" data-index="6">28</li>
                      <li class="js-tablist-trigger" data-index="7">29</li>
                      <li class="js-tablist-trigger" data-index="8">30</li>
                      <li class="js-tablist-trigger" data-index="9">31</li>
                    </ul>
                  </div>
                  <div
                    class="scroll_arrow imv2-arrow2_d js-scroll-trigger"
                    data-direction="1"
                  ></div>
                </div>
                <div class="week_content">
                  <div
                    class="content_hide js-tablist-content"
                    style="display: block"
                  >
                    <h6 class="content_title">
                      微服务架构认知、服务治理-Eureka
                    </h6>
                    <p class="content_default_text">
                      本周首先带大家从架构师的视角认识微服务架构以及SpringCloud和微服务架构的关系，
                      然后开始学习和改造服务治理Eureka。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>微服务架构的利弊以及面临的挑战</li>
                      <li>微服务的拆分规范，原则</li>
                      <li>阿里新零售业务商品中心的微服务化过程</li>
                      <li>SpringCloud和微服务架构的关系</li>
                      <li>SpringCloud整体架构</li>
                      <li>面对疯狂演进的版本，跟还是不跟？</li>
                      <li>电商系统微服务化的构想</li>
                      <li>服务治理技术选型Eureka VS Consul VS Nacos</li>
                      <li>如何看待Eureka2.0开源计划搁置对技术选型的影响</li>
                      <li>Eureka体系架构解析</li>
                      <li>创建服务注册中心</li>
                      <li>服务注册源码探秘</li>
                      <li>
                        服务发现，心跳监测与服务剔除，服务续约，服务自保，服务下线
                      </li>
                      <li>心跳检测和服务续约源码探秘</li>
                      <li>启用心跳和健康度检查</li>
                      <li>如何保证注册中心的高可用化，单中心宕机的思考</li>
                      <li>双备份注册中心 + 架构心得</li>
                      <li>电商系统用户模块集成Eureka</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">负载均衡、服务通信与调用</h6>
                    <p class="content_default_text">
                      本周我们需要借助Ribbon组件提供的负载均衡功能缓解访问压力。同时为了改善编程体验，我们会学习服务间调用功能-Feign。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>负载均衡技术选型（客户端 vs 服务器端）</li>
                      <li>Ribbon体系架构解析</li>
                      <li>为服务消费者添加负载均衡功能</li>
                      <li>懒加载与饥饿加载</li>
                      <li>负载均衡策略详解</li>
                      <li>探究负载均衡策略源码</li>
                      <li>深入了解LoadBalanced注解的底层机制</li>
                      <li>没有银弹！如何针对具体业务采用合适的负载均衡策略</li>
                      <li>电商系统用户模块统集成Ribbon</li>
                      <li>Ribbon可扩展性的研究-irule机制</li>
                      <li>自定义轮询式负载均衡策略</li>
                      <li>Feign体系架构解析</li>
                      <li>将Feign应用到服务消费者中</li>
                      <li>深入了解EnableFeignClient注解的底层机制</li>
                      <li>理想的Feign风格项目架构分享</li>
                      <li>配置重试和超时策略</li>
                      <li>深入了解FeignContract协议解析过程</li>
                      <li>电商系统用户模块统集成Feign</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">服务容错-Hystrix</h6>
                    <p class="content_default_text">
                      服务异常是生产环境中再正常不过的情况，轻则一行error
                      log，重则引发服务雪崩，把上下游的服务集群一波团灭。本周我们就来学习如果使用Hystrix处理服务调用异常。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>服务容错的解决方案 (降级和熔断)</li>
                      <li>
                        Hystrix体系架构解析（依赖隔离、服务降级、请求熔断）
                      </li>
                      <li>
                        服务降级原理及常用解决方案(FailFast, Timeout和Request
                        Cache)
                      </li>
                      <li>Feign+Hystrix实现Fallback降级</li>
                      <li>Hystrix实现Request Cache降级</li>
                      <li>多级降级方案(自定义降级处理类，二次降级)</li>
                      <li>超时降级 - 规避与Ribbon共同作用时的坑</li>
                      <li>Hystrix框架降级方案的触发方式（源码品读）</li>
                      <li>熔断器以及工作原理</li>
                      <li>Feign集成Hystrix熔断器</li>
                      <li>Hystrix熔断器参数的作用（源码品读）</li>
                      <li>降级熔断的业务规划（规划主链路/业务与容灾策略）</li>
                      <li>线程隔离 - 核心方案以及工作原理</li>
                      <li>线程池 vs 信号量的优缺点比较</li>
                      <li>聚合Hystrix监控信息 – Turbine和Hystrix Dashboard</li>
                      <li>通过Turbine聚合Consumer信息</li>
                      <li>电商系统用户模块集成Hystrix实现降级熔断</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">分布式配置中心</h6>
                    <p class="content_default_text">
                      在项目中一定经常遇到数不清的配置项和配置文件，管理起来十分头大，本周就带你一起玩转微服务下的配置管理组件
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>配置中心在微服务中的应用</li>
                      <li>Nacos与Apollo核心功能和体系架构</li>
                      <li>搭建配置中心</li>
                      <li>如何在运行期动态刷新配置项</li>
                      <li>如何对大规模集群进行刷新？总线式架构展望</li>
                      <li>对称性密钥进行加解密(保存私密信息)</li>
                      <li>
                        分布式配置中心的其他花式用法(环境配置项隔离/辅助服务降级/平滑灰度等)
                      </li>
                      <li>电商系统用户注册功能集成SCC</li>
                      <li>视野拓展-阿里系的分布式配置中心</li>
                      <li>视野拓展-配置中心在阿里新零售业务中的应用</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">消息总线、服务网关</h6>
                    <p class="content_default_text">
                      微服务架构中，少不了消息的传递和路由，本周我们就来学习一下消息总线-Bus和第二代服务网关-Gateway。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>网关组件选型Gateway vs Zuul</li>
                      <li>Gateway体系架构解析</li>
                      <li>Gateway路由功能详解（Route）</li>
                      <li>利用Path断言实现url映射</li>
                      <li>利用After断言实现定时秒杀场景</li>
                      <li>、自定义过滤器实现接口计时功能</li>
                      <li>Gateway过滤器机制源码解析</li>
                      <li>如何进行权限认证 - 分布式Session的替代方案有哪些</li>
                      <li>基于JWT实现用户鉴权</li>
                      <li>架构思考-如何借助网关层对服务端各类异常做统一处理</li>
                      <li>拓展-网关层的其他妙用 - 限流</li>
                      <li>为电商系统添加服务网关</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">服务调用链追踪、消息驱动</h6>
                    <p class="content_default_text">
                      排查线上异常是我们的日常任务，其中最重要的方式就是根据日志信息按图索骥摸排线索，本周我们学习Sleuth+Zipkin+ELK实现日志打标收集和搜索展示。之后拓展组件Stream。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>调用链追溯在微服务中的应用</li>
                      <li>
                        Zipkin，Pinpoint，SkyWalking三种服务链路监控组件分析与选型
                      </li>
                      <li>Sleuth核心功能和体系架构解析</li>
                      <li>调用链路数据模型 (Trace、Span、Annotation)</li>
                      <li>整合Sleuth追踪调用链路</li>
                      <li>解码解析-RequestHeader追踪调用链路的原理</li>
                      <li>Sleuth整合ELK实现日志检索</li>
                      <li>电商项目用户模块集成Sleuth + Zipkin</li>
                      <li>拓展-阿里新零售业务中商品发布的削峰策略</li>
                      <li>源码解析-探秘Stream Binder作用机制</li>
                      <li>基于发布订阅实现广播功能</li>
                      <li>阿里新零售业务利用发布订阅实现商品信息刷新</li>
                      <li>Stream中的消费组和消费分区机制</li>
                      <li>基于消费组实现轮询单播功能</li>
                      <li>Stream + MQ插件实现延迟消息、equeue操作</li>
                      <li>架构思考-异常情况导致消息无法被消费怎么办？</li>
                      <li>借助死信队列实现异常处理</li>
                      <li>定制自定义异常逻辑</li>
                      <li>电商项目引入Stream + MQ</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">微服务下Sentinel流量防控卫兵</h6>
                    <p class="content_default_text">
                      本周会手把手带大家学习一个高并发流量防护的利器-Sentinel，通过对Sentinel的学习和实践，让大家有能力解决你项目中的流控，降级等问题。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>Sentinel 与 Hystrix 的对比与选型</li>
                      <li>Sentinel哨兵全景分析</li>
                      <li>Sentinel哨兵核心API详解</li>
                      <li>源码解析-Sentinel哨兵核心主流程分析</li>
                      <li>Sentinel哨兵SpringAOP注解方式应用</li>
                      <li>Sentinel哨兵与主流框架的适配使用</li>
                      <li>Sentinel哨兵集群流控策与替代方案分享</li>
                      <li>Sentinel哨兵集成Apollo(携程的开源配置中心)</li>
                      <li>Apollo持久化规则扩展思路详解</li>
                      <li>Apollo配置文件解析与ApolloOpenApiClient创建</li>
                      <li>Apollo sentinel-dashboard扩展实现</li>
                      <li>Apollo 客户端集成sentinel-dashboard</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">服务治理的另一条路 - Dubbo</h6>
                    <p class="content_default_text">
                      本周属于拓展学习周，主要以图文的方式为大家拓展讲解Dubbo相关知识，希望通过本章的学习，
                      大家可以对基于RPC协议的服务治理有一个深刻的认知。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>RPC VS HTTP</li>
                      <li>Dubbo架构设计解析</li>
                      <li>Dubbo核心功能讲解</li>
                      <li>使用Zookeeper构建Dubbo注册中心</li>
                      <li>RPC协议解析流程</li>
                      <li>构建服务消费者</li>
                      <li>容错策略，负载均衡</li>
                      <li>基于Dubbo-Admin的服务治理</li>
                      <li>源码解析-Dubbo调用链路解析</li>
                      <li>拓展-阿里系王牌中间件 - HSF</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">应用监控与调优-工具篇</h6>
                    <p class="content_default_text">
                      本周我们先教大家如何迅速发现系统瓶颈，然后带大家掌握各种应用监控工具，从而为后面的监控与调优实战打好基础。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>开源的链路跟踪工具及对比</li>
                      <li>Skywalking监控Java应用</li>
                      <li>Skywalking监控数据库</li>
                      <li>Skywalking高可用</li>
                      <li>Skywalking存储</li>
                      <li>Spring Boot Actuator - 生产可用的应用监控工具</li>
                      <li>Prometheus - 监控工具</li>
                      <li>Grafana - 监控 + 告警工具</li>
                      <li>数据接入ELK</li>
                      <li>Zabbix 与 Prometheus对比</li>
                      <li>Tomcat Manager - Tomcat监控</li>
                      <li>psi-probe - Tomcat监控</li>
                      <li>日志监控， 慢SQL监控</li>
                      <li>Arthas线上调优实战</li>
                    </ol>
                  </div>
                </div>
              </div>
              <div class="step_title js-fold-trigger" data-index="5">
                <span>阶段五：</span>
                服务容器化Docker和K8S（32-35）
              </div>
              <div class="step_content js-fold-content">
                <div class="hide_scroll_bar js-fold-weeklist">
                  <div
                    class="scroll_arrow imv2-arrow2_u js-scroll-trigger disabled"
                    data-direction="-1"
                  ></div>
                  <div class="scroll_target_container js-scroll-target">
                    <ul class="week_title">
                      <li class="js-tablist-trigger active" data-index="1">
                        32
                      </li>
                      <li class="js-tablist-trigger" data-index="2">33</li>
                      <li class="js-tablist-trigger" data-index="3">34</li>
                      <li class="js-tablist-trigger" data-index="4">34</li>
                      <li class="js-tablist-trigger" data-index="5">35</li>
                    </ul>
                  </div>
                  <div
                    class="scroll_arrow imv2-arrow2_d js-scroll-trigger"
                    data-direction="1"
                  ></div>
                </div>
                <div class="week_content">
                  <div
                    class="content_hide js-tablist-content"
                    style="display: block"
                  >
                    <h6 class="content_title">服务容器化-Docker</h6>
                    <p class="content_default_text">
                      微服务架构改造后应用组件繁多，给服务部署带来了很大的挑战。本周我们就从热门技术Docker入手，解决服务部署难题。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>服务容器化优势和助力</li>

                      <li>服务容器化技术演进之路</li>

                      <li>容器技术选型Docker VS Cloud Foundry</li>

                      <li>Docker快速搭建，Docker整体架构解析</li>

                      <li>容器生命周期管理</li>

                      <li>Docker高级命令详解</li>

                      <li>
                        Dockerfile实战：如何站在巨人的肩膀上，实现快速部署
                      </li>

                      <li>如何实现容器间的网络访问和通信管理</li>

                      <li>Docker存储管理与选型</li>

                      <li>选择最适合你的容器镜像仓库</li>

                      <li>Docker生态圈：选型和优化</li>

                      <li>Docker落地实战，部署微服务</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">容器技术-Cloud Foundry</h6>
                    <p class="content_default_text">
                      本周为大家讲解容器部署另一分支解决方案-Cloud Foundry，
                      从架构和功能介绍到容器生命周期管理、网络和数据服务；逐步向后续的容器编排延伸。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>Cloud Foundry整体架构解析</li>

                      <li>Cloud Foundry环境搭建</li>

                      <li>Cloud Foundry常用命令实战，实现容器生命周期管理</li>

                      <li>Cloud Foundry网络管理(路由和访问控制)</li>

                      <li>基于Cloud Foundry网络特性实现业务蓝绿发布</li>

                      <li>
                        Cloud Foundry数据服务管理(关系型数据库/缓存/配置管理)
                      </li>

                      <li>如何实现数据持久层的高可用和业务连续性(架构思考)</li>

                      <li>
                        Cloud Foundry容器应用和PaaS平台双重管理(Ops & Aps
                        Manager)
                      </li>

                      <li>Cloud Foundry混合容器云架构和实践</li>

                      <li>Cloud Foundry落地实战，部署微服务</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">容器编排-Mesos+ Marathon</h6>
                    <p class="content_default_text">
                      本周为大家提供容器编排第一套解决方案-Mesos+Marathon，助力大家搞定容器编排难题，让你的项目从应用架构向企业架构过渡。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>Mesos+Marathon整体架构解析</li>

                      <li>Mesos+Marathon环境搭建和小试牛刀</li>

                      <li>Mesos资源管理原理剖析与实战</li>

                      <li>Mesos实现DCOS多类型负载综合管理</li>

                      <li>
                        Marathon调度器原理剖析与实战(常驻服务生命周期管理)
                      </li>

                      <li>Marathon应用隔离和依赖管理</li>

                      <li>如何实现无单点、大集群容器编排管理</li>

                      <li>Mesos+Marathon落地实战，部署微服务</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">容器编排-K8S</h6>
                    <p class="content_default_text">
                      本周我们一起来学习K8S容器编排。我们会以企业架构师的视野，重新审视容器化编排。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>K8S整体架构及常用命令</li>

                      <li>K8S调度原理剖析与Pod生命周期管理</li>

                      <li>K8S控制器管理原理剖析与实战</li>

                      <li>K8S网络模型和服务访问管理</li>

                      <li>K8S服务发现与负载均衡原理剖析与实战</li>

                      <li>K8S系统分层架构和故障排除思路</li>

                      <li>K8S存储原理实战(数据卷和配置管理)</li>

                      <li>K8S认证授权原理剖析与实战(安全框架/RBAC)</li>

                      <li>K8S集群监控、快速故障排查和业务连续性保障</li>

                      <li>如何实现大规模集群？10节点->100节点->1000节点</li>

                      <li>全链路高可用架构升级</li>

                      <li>知识扩展-如何基于容器编排工具实现CI/CD</li>

                      <li>K8S统一日志管理</li>

                      <li>K8S集群自定义API资源</li>

                      <li>K8S落地实战，部署微服务</li>

                      <li>K8S紧急状态时的node管理与pod驱逐机制</li>
                    </ol>
                  </div>
                  <div class="content_hide js-tablist-content">
                    <h6 class="content_title">容器弹性扩缩容</h6>
                    <p class="content_default_text">
                      本周为大家分享容器弹性扩缩容整体架构思路。我们会采用Cloud
                      Foundry实现资源决策性弹性扩缩容；
                      采用Mesos+Marathon实现负载驱动型动态扩缩容；采用K8S增值插件实现全自由扩缩容。
                    </p>
                    <h6 class="content_title">课程安排：</h6>
                    <ol>
                      <li>资源管理、属性和配额管理</li>

                      <li>有状态应用如何实现弹性伸缩和失效重置</li>

                      <li>容器弹性扩缩容实现资源触发、简单决策</li>

                      <li>容器弹性扩缩容实现负载触发、动态扩缩容</li>

                      <li>容器弹性扩缩容实现更换轮子、自由扩缩容</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import courseSystem2 from '../courseSystem2'
import work from './components/work'
import $ from './mcaStatic/js/jquery.min.js'
import './mcaStatic/js/index_ca435f7.js'
export default {
  components: {
    courseSystem2,
    work
  },
  data() {
    return {}
  },
  created() {},
  mounted() {
    $('.step_title').click(function() {
      if (
        $(this)
          .next()
          .is(':hidden')
      ) {
        $(this)
          .siblings()
          .removeClass('highlight')
        $(this).addClass('highlight')
        $(this)
          .parent()
          .find('.js-fold-content')
          .slideUp(300)
        $(this)
          .next()
          .slideDown(300)
      }
    })

    $('.js-tablist-trigger').click(function() {
      $(this)
        .siblings()
        .removeClass('active')
      $(this).addClass('active')
      $(this)
        .closest('.js-fold-content')
        .find('.js-tablist-content')
        .hide()
        .eq(+$(this).attr('data-index') - 1)
        .show()
    })
  }
}
</script>

<style>
@import url('./mcaStatic/css/common_d42b1ef.css');
@import url('./mcaStatic/css/index_9795269.css');
@import url('./mcaStatic/css/evaluate-item_507e3ee.css');
@import url('./mcaStatic/css/javaarchitect-less.css');
@import url('./mcaStatic/css/weekcontent_javaarchitect_234133a.css');
</style>

<style>
body {
  width: 100%;
  min-width: 100%;
}
body div.course-info {
  text-align: left;
}
body .course-info div.banner {
  background-image: url('//mashibing.com/mcaImage/5f72c89d0869c1b111250765.jpg');
}
body .page-header-nav.fixed {
  position: fixed;
  box-shadow: 0 4px 8px 0 rgba(28, 31, 33, 0.1);
  top: 0 !important;
}

.week_content ol {
  padding-left: 30px !important;
  list-style-type: decimal !important;
}

.java-button {
  font-size: 0.34rem;
  border: 1px solid #979797;
  border-radius: 8px;
  padding: 0.4rem;
  margin-top: 0.4rem;
}

.java-title {
  background: #6253c9;
  font-size: 0.34rem;
  color: #fff;
  cursor: default;
}

.java-main {
  padding: 0.2rem;
  background: #ffffff;
}

.title-empty {
  color: #6253c9;
  background: #f8fafc;
  border: 1px solid #6253c9;
}
div.week_content_container .week_wrapper {
  text-align: left;
}
div.week_content_container .week_wrapper .week_content {
  background: #fff;
}

.system_wrapper .item_index {
  margin-top: 0.8rem !important;
}

.system_wrapper .item_content span {
  min-height: 0.8rem !important;
}

@media (max-width: 768px) {
  .system_wrapper {
    width: 100%;
    padding: 30px;
  }

  .system_wrapper h1 {
    font-size: 30px;
  }

  .system_wrapper h4 {
    font-size: 0.37333333rem !important;
  }

  .system_wrapper .item_content span {
    width: 96% !important;
    margin: 0 2% 10px 2% !important;
    padding: 4px;
  }
}

.main_title {
  color: #1c1f21;
  font-size: 0.47333333rem;
  text-align: center;
}

.system_wrapper {
  box-sizing: border-box;
}

.system_wrapper h1 {
  color: #1890ff;
  font-weight: 700;
}

.system_wrapper h4 {
  font-size: 18px;
  color: #48576a;
}

.system_wrapper .item {
  text-align: left;
}

.system_wrapper .item_index {
  font-size: 0.47333333rem;
  font-weight: 700;
  color: #1890ff;
  margin-top: 20px;
  position: relative;
}

.system_wrapper .item_index :after {
  content: '';
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #1890ff;
  transform: rotate(-135deg);
  left: 27px;
  bottom: 9px;
}

.system_wrapper .item_title {
  font-size: 0.47333333rem;
  font-weight: 700;
  color: #000;
  text-indent: 40px;
  font-style: italic;
  margin-bottom: 20px;
}

.system_wrapper .item_title span {
  position: relative;
}

.system_wrapper .item_title span :after {
  content: '-';
  position: absolute;
  bottom: -14px;
  font-size: 40px;
  right: -5px;
  color: #1890ff;
}

.system_wrapper .item_content {
  box-shadow: 1px 2px 0.37333333rem 12px hsla(0, 0%, 39.2%, 0.1);
  border-radius: 3px;
  padding: 2% 2%;
  display: flex;
  flex-flow: row wrap;
}

.system_wrapper .item_content span {
  cursor: pointer;
  font-size: 0.37333333rem;
  width: 206px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 12px 17px 12px;
  color: #909090;
  background: #e8e8e8;
  border-radius: 5px;
  text-align: center;
}

.system_wrapper .item_content span :hover {
  color: #fff;
  background: #1890ff;
}
</style>
